module.exports = __webpack_public_path__ + "img/yuanfudao-propa.2568e0ab.png";